import { ElementFactory } from "./ElementFactory";
import { ObjectElement } from "./ObjectElement";
/**
 * Object Element Factory
 */
export class ObjectElementFactory extends ElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return new ObjectElement(htmlElement, bindData, context);
    }
}
//# sourceMappingURL=ObjectElementFactory.js.map